import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import MyTags from './components/MyTags';
app.initializers.add('acpl/my-tags', () => {
  extend(IndexSidebar.prototype, 'navItems', items => {
    if (!app.session.user) return;
    items.add('my-tags', m(MyTags, null), -13);
  });
});